import { useMutation } from '@tanstack/react-query';
import { selectOrganization } from '../services/auth_service';

export const useSelectOrganization = () => {
    return useMutation({
        mutationFn: selectOrganization,
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.error('Failed to select organization:', error);
        }
    });
};
